import { i18n } from '@fs/zion-locale'

import { LANG, NAME_PART_TYPE, NAME_TYPE, ORDER } from '../../constants'

// This object represents the minimum data needed to create a new person name.
export default Object.freeze({
  preferred: true,
  value: {
    nameForms: [
      {
        lang: LANG.traditional,
        order: ORDER.eastern, // (lastName firstName)
        parts: [
          {
            type: NAME_PART_TYPE.surname,
            value: i18n.t('entities.person.unknownSurname', 'Unknown'), // A value is required
          },
        ],
        separator: '', // No space for Eastern style, use a space for Western style
      },
    ],
    type: NAME_TYPE.birthName,
  },
})
